module.exports = __webpack_public_path__ + "static/suitsCard.da279c9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/suitsCard.jpg
// module id = 469
// module chunks = 114276838955818